import an1 from './an1.webp';
import an2 from './an2.png';
import an3 from './an3.png';
import an4 from './an4.webp';
import an5 from './an5.jpg';
import an6 from './an6.png';
import an7 from './an7.png';
import pen1 from './pen1.png';
import pen2 from './pen2.webp';
import pen3 from './pen3.png';
import pen4 from './pen4.webp';
import pen5 from './pen5.png';
import pen6 from './pen6.png';
import pen7 from './pen7.png';
import pul1 from './pul1.png';
import pul2 from './pul2.png';
import pul3 from './pul3.png';
import pul4 from './pul4.png';
import pul5 from './pul5.png';
import pul6 from './pul6.jpg';
import pul7 from './pul7.png';

export const data = [

    {
  
      id: 1,
  
      name: "ANILLO NEW BERN",
  
      searchTerm: "anillo",
  
      price: 2500,

      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      image: an1  
    },
  
    {
  
      id: 2,
  
      name: "PENDIENTES DE GRANDES ESPERANZAS",
  
      searchTerm: "pendientes",
  
      price: 2100,
      showMore: false,
      description: "Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates. ", 
  
      image: pen1
  
    },
  
  
  
    {
  
      id: 3,
  
      name: "PULSERA RIVIERE",
  
      searchTerm: "pulsera",
  
      price: 1900,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul1
  
    },
  
  
  
    {
  
      id: 4,
  
      name: "ANILLO ROMERIA",
  
      searchTerm: "anillo",
  
      price: 3400,
      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      image: an2

    },
  
  
  
    {
  
      id: 5,
  
      name: "PENDIENTES DE GRACE",
  
      searchTerm: "pendientes",
  
      price: 1650,
      showMore: false,
      description: "Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates. ", 
  
      image: pen2
  
    },
  
    {
  
      id: 6,
  
      name: "PULSERA LA DECO",
  
      searchTerm: "pulsera",
  
      price: 2600,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul2
  
    },
  
    {
  
      id: 7,
  
      name: "ANILLO DE VERIS",
  
      searchTerm: "anillo",
  
      price: 2100,
      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      image: an3
  
    },
  
    {
  
      id: 8,
  
      name: "PENDIENTES DE IDALIA",
  
      searchTerm: "pendientes",
  
      price: 3500,
      showMore: false,
      description: " Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates.", 
  
      image: pen3
  
    },
  
    {
  
      id: 9,
  
      name: "PULSERA DE IDALIA",
  
      searchTerm: "pulsera",
  
      price: 6000,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul3
  
    },
  
    {
  
      id: 10,
  
      name: "ANILLO DE IDALIA",
  
      searchTerm: "anillo",
  
      price: 1200,
      showMore: false,
      description: " Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates.", 
  
      image: an4
  
    },
  
    {
  
      id: 11,
  
      name: "PENDIENTES DE GERIAS",
  
      searchTerm: "pendientes",
  
      price: 9500,
      showMore: false,
      description: " Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates.", 
  
      image: pen4
  
    },
  
    {
  
      id: 12,
  
      name: "PULSERA DE GRACE",
  
      searchTerm: "pulsera",
  
      price: 7500,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul4
  
    },
  
    {
  
      id: 13,
  
      name: "ANILLO DE ORION",
  
      searchTerm: "anillo",
  
      price: 1400,
      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      image: an5
  
    },
  
    {
  
      id: 14,
  
      name: "PENDIENTES DE VERIS",
  
      searchTerm: "pendientes",
  
      price: 9000,
      showMore: false,
      description: "Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates. ", 
  
      image: pen5
  
    },
  
    {
  
      id: 15,
  
      name: "PULSERA DE ORION",
  
      searchTerm: "pulsera",
  
      price: 3200,
      showMore: false,
      description: " Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates.", 
  
      image: pul5
  
    },
  
    {
  
      id: 16,
  
      name: "ANILLO DE ORION",
  
      searchTerm: "anillo",
  
      price: 1400,
      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      image: an6
  
    },
  
    {
  
      id: 17,
  
      name: "PENDIENTES DE VERIS",
  
      searchTerm: "pendientes",
  
      price: 9000,
      showMore: false,
      description: " Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates.", 
  
      image: pen6
  
    },
  
    {
  
      id: 18,
  
      name: "PULSERA DE ORION",
  
      searchTerm: "pulsera",
  
      price: 3200,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul6
  
    },

    {
  
      id: 19,
  
      name: "ANILLO DE ORION",
  
      searchTerm: "anillo",
      showMore: false,
      description: "Anillo de oro blanco de 18 quilates con esmeralda verde central en talla esmeralda de 1,18 quilates y 32 diamantes en talla redonda con un peso total de 0,38 quilates. ", 
  
      price: 1400,
  
      image: an7
  
    },
  
    {
  
      id: 20,
  
      name: "PENDIENTES DE VERIS",
  
      searchTerm: "pendientes",
  
      price: 9000,
      showMore: false,
      description: "Pendientes de oro blanco de 18 quilates con 2 zafiros azules en talla redonda con un peso total de 0,47 quilates y 16 diamantes blancos en talla redonda con un peso total de 0,45 quilates. ", 
  
      image: pen7
  
    },
  
    {
  
      id: 21,
  
      name: "PULSERA DE ORION",
  
      searchTerm: "pulsera",
  
      price: 3200,
      showMore: false,
      description: "Pulsera de oro blanco de 18 quilates con corazón de diamantes talla brillante con un total de 0,06 quilates. ", 
  
      image: pul7
  
   }
  ]
  
  